/* eslint-disable */
import React from 'react'

import Loader from 'react-js-loader'
import Lottie from 'react-lottie-player'
import LoderJson from '../assets/images/loader.json'

const AppLoader = () => {
  return (
    <>
      {/* package loader */}
      {/* <div>
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          {' '}
          <Loader
            type="box-rotate-y"
            bgColor="#3498db"
            color="#FFFFFF"
            title={'box-rotate-y'}
            size={100}
          />
          <div className="loader"></div>
        </div>
      </div> */}

      {/* custom loader */}
      {/* <div className="m-loader">
        <div className="m-loader--rounds">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div> */}

      {/* lottie loader */}
      <div className="m-loader">
        <Lottie loop animationData={LoderJson} play style={{ width: 150, height: 150 }} />
      </div>
    </>
  )
}

export default AppLoader
